import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

export const columns = [
  {
    id: 'vehicleName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.vehicle'),
  },
  {
    id: 'drivers',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('fuelConsumption.currentDrivers'),
  },
  {
    id: 'jurisdictionLocation',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: checkServiceProvider('config_jurisdictionLocation', window.$environment?.SERVICE_PROVIDER, false),
  },
  {
    id: 'milesPerGallon',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('fuelConsumption.miles'),
  },
  {
    id: 'history',
    numeric: false,
    disablePadding: false,
    label: i18n.t('fuelConsumption.history'),
  },
];
